module.exports = __webpack_public_path__ + "img/receivable.43445d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/receivable.png
// module id = I2Sz
// module chunks = 149